export const ValidationRules = {
    // 口座名義人
    bank_account_holder: [{ rule: 'required', event: 'blur', action: 'radio' }],
    // 口座名義人名
    bank_account_holder_name: [
        { rule: 'required', event: 'blur', action: 'input' },
        { rule: 'string', event: 'input', action: 'input' },
        { rule: 'kana_with_space', event: 'blur' }
    ],
    // // 口座登録
    // bank_account_registration: [{ rule: 'required', event: 'blur', action: 'radio' }],
    // // A済 日付
    // bank_account_registration_date: [
    //     { rule: 'required_if:bank_account_registration,A済', event: 'blur', action: 'input' },
    //     { rule: 'date', event: 'blur,change' }
    // ],
    // 確認日時
    beri_timing: [{ rule: 'required', event: 'blur', action: 'radio' }],
    // ベリ指定日時
    beri_at: [
        { rule: 'required_if:beri_timing,指定日時選択', event: 'blur', action: 'input' },
        { rule: 'date', event: 'blur,change' }
    ]
}

/**
 * Vueファイル側での確認バリデーション
 */
export const ValidationMaxSheets = {
    identification: 5, // 本人確認書類
    contract_documents: 5, // エステ契約書、美容医療契約書、売買契約書、口座振替依頼書等
    parental_consent: 2 // 親権者同意書
}